/** UUID shape used for PAM / DynamoDB user ids, e.g. `410b9570-0061-70fd-c4b8-c0724373153d`. */
const USER_ID_UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True when `value` is a string UUID suitable for User Manager deep links. */
export function verifyUserId(value: unknown): value is string {
  return typeof value === "string" && USER_ID_UUID_RE.test(value);
}
